import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import clsx from 'clsx';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { useDevice } from '@bonnet/next/device';

import { Link } from 'reaxl';

import getPathSRP from '@/utilities/getPathSRP';

import queryDuck from '@/ducks/queryDuck.js';

// Commercial SRP Entry Point Filter Component
function CommercialSrpFilterEntryPoint({
    className = '',
    icon,
    onCommercialEntryPointClick = () => { },
}) {

    const device = useDevice();
    const isMd = _get(device, 'is.md', false);

    const query = useSelector(queryDuck.selectors.getDuckState);
    const [commercialPath, setCommercialPath] = useState('');

    useEffect(() => {
        const commercialQuery = { ...query };

        delete commercialQuery.makeCode;
        delete commercialQuery.modelCode;
        delete commercialQuery.trimCode;
        delete commercialQuery.vehicleStyleCode;
        delete commercialQuery.zip;
        delete commercialQuery.state;
        delete commercialQuery.city;

        const generateCommercialSrpPath = async () => {
            const path = await getPathSRP({ ...commercialQuery, experience: 'commercial' }, { basePath: true });
            setCommercialPath(path);
        };

        if (!_isEmpty(commercialQuery)) {
            generateCommercialSrpPath();
        }
    }, [query]);

    return (
        <div
            className={className}
            data-cmp="commercial-srp-filter-entry-point"
        >
            <Link
                data-cmp="commercial-srp-entry-point-link"
                href={commercialPath}
                className={clsx('text-link link-undecorated', {
                    'padding-left-2': !isMd,
                })}
                onClick={onCommercialEntryPointClick}
            >
                Shop commercial vehicles
            </Link>
        </div>
    );
}

export default CommercialSrpFilterEntryPoint;
